import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import rootReducer from "./store/reducers";
import rootSaga from "./store/sagas";
import App from "./pages";
import "./styles/styles.scss";
import "react-datepicker/dist/react-datepicker.css";
import "regenerator-runtime/runtime";
import "./translations/i18n";


const composeEnhancers =
  (process.env.NODE_ENV !== "production" &&
    typeof window !== "undefined" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const sagaMiddleware = createSagaMiddleware();
const middlewares = [applyMiddleware(sagaMiddleware)];
const store = createStore(rootReducer, composeEnhancers(...middlewares));

// App

const app = (
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>
);

sagaMiddleware.run(rootSaga);

ReactDOM.render(app, document.getElementById("root"));
